/**
 * Lives in `shared/src/review/uncaptured-gap.ts` so the Dashboard, `/review` and the brief's prose
 * read one rule (owner D4). Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  claimedGapLine,
  uncapturedGapHeadlineStat,
  uncapturedGapNote,
  uncapturedGapStat
} from '@taptimize/shared/dist/review/uncaptured-gap';
export type { UncapturedGapScale } from '@taptimize/shared/dist/review/uncaptured-gap';
